import React, { useState } from "react";
import Snackbar from "../../../../../components/snackbar/snackbar";
import CheckBox from "../../../../../components/inputs/checkbox";
import CustomButton from "../../../../../components/inputs/button";
import TextField from "../../../../../components/inputs/textfield";
import { user_deactivate } from "../../../user.api";

const ManageDeactivate = (props) => {
  const [answer, setAnswer] = useState("");
  const [formData, setFormData] = useState({});

  const handleChange = (e) => {
    let value = e.target.value;
    let name = e.target.name;

    setFormData({ ...formData, [name]: value });
  };
 
  console.log(props?.appData);
  return (
    <React.Fragment>
      {props.open && (
        <React.Fragment>
          <div className="overlay">
            <div className="deactivatePopup">
              <div className="d-flex flex-column">
                <div className="">
                  <div className="flexDisplay">
                    <div className="diaTitleCon">Reason for deactivation</div>
                    <div
                      className="dia-close"
                      onClick={() => props.handleOpen(false)}
                    >
                      <div className="diaCloseCon">
                        <div className="diaClose">&#10005;</div>
                      </div>
                    </div>
                  </div>

                  <div className="tilebars">
                    <hr />
                  </div>
                </div>
               
                  <div className="row book-form">
                    <div className="">
                      <div className="col-12">
                        <div className="col-12">
                          <textarea
                            autoComplete="off"
                            className=" form-control  mb-2"
                            onChange={(e) => handleChange(e)}
                            value={formData.reason ?? ""}
                            name="reason"
                            style={{ height: "200px", maxHeight: "400px" }}
                            required
                          />
                        </div>
                      </div>
                    </div>

                    <div className="col-12 pt-2">
                      <CustomButton
                        label="Submit"
                        onClick={() => props.handleDeactivate(props.appData?.id, formData)}
                      />
                    </div>
                  </div>
                
              </div>
            </div>
          </div>
        </React.Fragment>
      )}
    </React.Fragment>
  );
};

export default ManageDeactivate;
